var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.676,
    height: 5.641,
    viewBox: "0 0 5.676 5.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.821 3.291l2 2a.333.333 0 00.47-.469l-2-2 2-2A.333.333 0 004.822.35l-2 2-2-2a.333.333 0 10-.471.471l2 2-2 2a.333.333 0 00.471.471zm0 0",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.d45f0db3.svg";
export { ForwardRef as ReactComponent };